export default __webpack_public_path__ + "static/media/google-logo-removebg-preview.ecdb4d02.png";